const React = require('react')
require('@styles/components/loading.style.css')

const LoadingSpinner = () => {
    return (
        <div className='loading-img'>
            <lottie-player
                src='https://assets4.lottiefiles.com/packages/lf20_rosmd0fk.json'
                background='transparent'
                speed='1.5'
                style={{ width: '100%', height: '100%' }}
                loop
                autoplay
            ></lottie-player>
        </div>
    )
}

module.exports = { LoadingSpinner }
